export default {
    title: 'Imports',
    addImport: 'New import',
    createImport: 'Create new import',
    evolution: 'Evolution',
    evolutionModal: {
        title: 'Data evolution',
        from: 'From',
        to: 'To',
        countTitle: 'Insight data count as of: {date}',
        variation: 'Variation',
        capture: 'Capture now',
        captureSuccess: 'Snapshot captured successfully',
        empty: 'No snapshots captured yet.',
        needTwo: 'Capture at least two snapshots (on different dates, or after importing data) to see the variation.',
    },
    empty: {
        title: 'Not found imports',
        text: 'We did not find any imports for your search.',
    },

    steps: {
        upload: 'Upload',
        generate: 'Generate',
        validation: 'Validation',
        preview: 'Preview',
    },

    updates: {
        rows: 'No new rows | 1 new row | {count} new rows',
        cells: 'No cells updated | 1 cell updated | {count} cells updated',
    },

    notifications: {
        errors: 'No errors | 1 error | {count} errors',
        warnings: 'No warnings | 1 warning | {count} warnings',
    },

    list: {
        tabs: {
            history: 'History',
            ocrUploads: 'OCR Uploads',
            archives: 'Archives',
        },
    },

    create: {
        title: 'Create',
        downloadTemplate: 'Download template',
        updateField: 'Update field',
        low: 'Low',
        high: 'Hight',

        cancel: 'Cancel',
        force: 'Force',
        save: 'Save',
        confirm: 'Confirm',
        return: 'Imports list',

        yes: 'Yes',
        no: 'No',
        alert: 'Alert',

        form: {
            entity: {
                label: 'Entity',
                placeholder: 'Select entity',
            },
            source: {
                label: 'Source',
                placeholder: 'Select source',
            },
            name: {
                label: 'File name',
                placeholder: 'Set a file name',
            },
            file: {
                label: 'Attachment',
                placeholderOne: 'Choose a file ',
                placeholderTwo: 'or drag it here',
            },
        },

        modals: {
            CANCEL: {
                text: 'Do you want to cancel the import? You will lose the data.',
            },
            FORCE: {
                text: 'Do you want to force the import? Cell with errors will not be imported.',
            },
            ERROR: {
                title: 'Uups...',
                text: 'Validation error. Please, try again or contact us.',
            },
            NOT_FOUND: {
                title: 'Uups...',
                text: 'Import not found. Please, try again or contact us.',
            },
            SUCCESS: {
                title: 'Great!',
                text: 'Import created successfully.',
            },
            REJECT: {
                title: 'Confirm',
                text: 'Do you want to reject the draft?.',
            },
            DISCARD: {
                title: 'Confirm',
                text: 'Do you want to discard the draft?.',
            },
        },

        notifications: {
            warning: 'Warning | Warning | Warnings',
            error: 'Input required | Input required | Input required',
            info: 'Info | Info | Infos',
            success: 'Great!',
            successText: 'Data imported successfully',
        },

        issues: {
            title: 'Issues',
            error: 'Error',
            edit: 'Edit',
            normalization: 'Normalization',

            form: {
                currentValue: {
                    label: 'Current value',
                },
                value: {
                    label: 'New Value',
                    placeholder: 'Set a new value',
                },

                cancel: 'Cancel',
                next: 'Next',
                submit: 'Save',
            },
        },

        generate: {
            default: 'Generating ...',
        },
    },

    detail: {
        resources: {
            performance: 'Track record',
            transactions: 'Portfolio performance',
            trans: 'Fund Deals',
            funds: 'Funds',
        },
    },

    modals: {
        archive: {
            text: 'Do you want to archive the import?',
        },
        unarchive: {
            text: 'Do you want to unarchive the import?',
        },
        cancel: {
            text: 'Do you want to cancel the import?',
        },
        deleteRows: {
            text: 'Do you want to delete this row? | Do you want to delete this row? | Do you want to delete these rows?',
        },
        createSuccess: {
            title: 'Great!',
            text: 'Import create successfully.',
        },
        archiveSuccess: {
            title: 'Great!',
            text: 'Import archive successfully.',
        },
        cancelSuccess: {
            title: 'Great!',
            text: 'Import cancel successfully.',
        },
        acceptSuccess: {
            title: 'Great!',
            text: 'Import updated successfully.',
        },
        rejectSuccess: {
            title: 'Great!',
            text: 'Import rejected successfully.',
        },
        discardSuccess: {
            title: 'Great!',
            text: 'Import discarted successfully.',
        },
        accept: {
            title: 'Confirm',
            text: 'Do you want to accept the selected record?',
        },
        reject: {
            title: 'Confirm',
            text: 'Do you want to reject the selected record?',
        },
        discard: {
            title: 'Confirm',
            text: 'Do you want to discard the selected record?',
        },
    },

    status: {
        completed: 'IMPORTED',
        running: 'RUNNING',
        queued: 'QUEUED',
        pending_review: 'PENDING REVIEW',
        cancelled: 'CANCELLED',
        failed: 'FAILED',
    },

    actions: {
        view: 'View',
        archive: 'Archive',
        unarchive: 'Unarchive',
        cancel: 'Cancel',
        download: 'Download',
    },
}
